// @flow
import { createEpicMiddleware } from 'redux-most';
import { createStore, applyMiddleware } from 'redux';
import infrastructureComposite from './infrastructure/composite';
import domainComposite from './domain/composite';
import applicationComposite from './application/composite';
import reducer from './domain/reducers';
import {
  composeWithDevTools,
} from 'redux-devtools-extension/logOnlyInProduction';

export const setupStore = (
  epicMiddleware,
) => {
  return createStore(
    reducer,
    composeWithDevTools(
      applyMiddleware(
        epicMiddleware,
      ),
    ),
  );
};

export const setupEpics = () => {
  const infrastructure = infrastructureComposite();

  const domain = domainComposite({
    getBrowserSession: infrastructure.browserSession.getBrowserSession,
    createBrowserSession: infrastructure.browserSession.createBrowserSession,
  });
  const application = applicationComposite({
    analyticsQueue: infrastructure.analyticsQueue,
    isFqdnAvailable: infrastructure.fqdn.isFqdnAvailable,
    getSuggestions: infrastructure.suggestions.getSuggestions,
    analyticsContext: infrastructure.analyticsContext,
    getSessionId: domain.browserSession.getBrowserSessionId,
    initialize: infrastructure.ga.initialize,
    sendAnalytics: infrastructure.ga.sendAnalytics,
    emit: infrastructure.events.emit,
  });

  return application;
};

export const setupMiddleware = (epics) => {
  const middleware = createEpicMiddleware(epics);
  return middleware;
};

export default () => {
  const epics = setupEpics();
  const middleware = setupMiddleware(epics);
  const store = setupStore(middleware);

  return {
    store,
  };
};
